import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "o-container -container-max" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "o-filter__accordion__toggler__text" }, " Filtrer les résultats ", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "o-filter__accordion__toggler__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    focusable: "false",
    class: "o-ico"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#filter" })
  ])
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "o-filter__accordion__content" }
const _hoisted_6 = { class: "o-filter__accordion__content__inner" }
const _hoisted_7 = { class: "o-filter u-color-1 u-bg-color-1-lightest" }
const _hoisted_8 = { class: "o-form__wrap" }
const _hoisted_9 = { class: "o-form" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-sm" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "o-flex" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-line" }, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "o-subtitle" }, " Recherchez ", -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-sm" }, null, -1 /* HOISTED */)
const _hoisted_16 = { class: "o-flex -flex-gap -flex-space-between" }
const _hoisted_17 = { class: "o-flex__item" }
const _hoisted_18 = { class: "o-flex -flex-gap-xs -flex-wrap o-form-group" }
const _hoisted_19 = { class: "o-flex__item" }
const _hoisted_20 = { class: "o-form-group__item" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "recherche"
}, "Recherche", -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico o-input__icon"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#search" })
], -1 /* HOISTED */)
const _hoisted_23 = { class: "o-flex__item -flex-align-self-end" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-line" }, null, -1 /* HOISTED */)
const _hoisted_25 = { class: "o-flex -flex-wrap -flex-gap-xxs" }
const _hoisted_26 = { class: "o-flex__item" }
const _hoisted_27 = { class: "o-filter__active" }
const _hoisted_28 = { class: "o-filter__active__text" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#close" })
], -1 /* HOISTED */)
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["o-filter__accordion", {'is-open': $data.isOpen}])
    }, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = $event => ($data.isOpen=!$data.isOpen)),
        class: "o-filter__accordion__toggler"
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("form", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.alphabet, (letter) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass(["-text-bold", {'is-active': $data.selectedLetter==letter}]),
                      onClick: _withModifiers($event => ($options.toggleLetter(letter)), ["prevent"])
                    }, _toDisplayString(letter), 11 /* TEXT, CLASS, PROPS */, _hoisted_12))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]),
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _withDirectives(_createElementVNode("input", {
                            onKeyup: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                            onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                            class: "o-input -input-has-icon",
                            type: "text",
                            id: "prenom",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.searchInput) = $event)),
                            placeholder: "Mots-clés ex. Roman"
                          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [_vModelText, $data.searchInput]
                          ]),
                          _hoisted_22
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = _withModifiers($event => ($options.reset()), ["prevent"])),
                      class: "o-form__button__reset"
                    }, " Réinitialiser ")
                  ])
                ]),
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(tag.label), 1 /* TEXT */),
                        _createElementVNode("button", {
                          onClick: _withModifiers($event => ($options.removeTag(tag)), ["prevent"]),
                          class: "o-filter__active__close"
                        }, _hoisted_31, 8 /* PROPS */, _hoisted_29)
                      ])
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ])
              ])
            ])
          ])
        ])
      ])
    ], 2 /* CLASS */)
  ]))
}